"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useModalContext = exports["default"] = exports.ROOT_TRANSTION_CLASS = exports.ModalContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTransitionGroup = require("react-transition-group");
var _isBrowser = _interopRequireDefault(require("../../utils/is-browser"));
var _sharedVariables = require("../../shared-variables");
var _modalPortal = _interopRequireDefault(require("./modal-portal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ModalContext = exports.ModalContext = /*#__PURE__*/(0, _react.createContext)({});
var useModalContext = exports.useModalContext = function useModalContext() {
  return (0, _react.useContext)(ModalContext);
};
var ROOT_TRANSTION_CLASS = exports.ROOT_TRANSTION_CLASS = 'sb-modal-transition';

/**
 * An accessible modal component manager. ModalProvider does not create any UI of its own;
 * it is intended to work with the modal UI components in this library such as Overlay.
 * ModalProvider will handle opening and closing your UI component and manages focus,
 * close on Escape, mask animation, and key accessible attributes.
 *
 * There are four main steps to leverage ModalProvider:
 *
 * The main export, ModalProvider, should be wrapped around your entire React application
 * as near to the application root as possible. ModalProvider leverages React Context
 * to expose the openModal and closeModal methods to your entire app.
 *
 * In your html, create a sibling div to your React app's root div. Set a unique id attribute
 * on that div, and pass that id as the targetElementId prop of the ModalProvider created in
 * step one. ModalProvider uses a React Portal, and this targetElementId tells the provider
 * where to render your modals. Using a sibling div to the react app makes z-index handling
 * much easier.
 *
 * For accessibility, we want to mark the main React app hidden from screen readers when a modal
 * is open. For this reason, pass the id of the element to which your React app is mounted as the
 * appElementId prop of the ModalProvider.
 *
 * In your application, wherever you need to launch a modal, import ModalContext from this
 * component, and access it using the React.useContext hook. This will give you access to
 * the openModal method; now you simply pass the component you want to render to openModal via
 * its 'component' property. See example to the right.
 *
 * Also check out our Overlay docs for an
 * <a href="/components/overlay">example using Overlays</a>.
 *
 */

// *** DO NOT CONVERT TO FUNCTIONAL COMPONENT ***
// Until addressing the shared state issue in MFA & Re-Auth components in core
// More info about the issue: https://scm.starbucks.com/starbucks-web/pattern-library/pull/1155/files#r390910
var ModalProvider = /*#__PURE__*/function (_Component) {
  _inherits(ModalProvider, _Component);
  var _super = _createSuper(ModalProvider);
  function ModalProvider() {
    var _this;
    _classCallCheck(this, ModalProvider);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "openModal", function (_ref) {
      var _window;
      var ariaLabel = _ref.ariaLabel,
        ariaLabelledBy = _ref.ariaLabelledBy,
        ModalComponent = _ref.component,
        componentProps = _ref.componentProps,
        id = _ref.id,
        modalRootProps = _ref.modalRootProps,
        _ref$onClose = _ref.onClose,
        onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
        _ref$onEscape = _ref.onEscape,
        onEscape = _ref$onEscape === void 0 ? function () {} : _ref$onEscape;
      _this.setState({
        openModalLayers: _this.state.openModalLayers.concat([{
          ariaLabel: ariaLabel,
          ariaLabelledBy: ariaLabelledBy,
          Component: ModalComponent,
          componentProps: componentProps,
          id: id,
          modalRootProps: modalRootProps,
          onClose: onClose,
          onEscape: onEscape,
          returnFocusTarget: (_window = window) === null || _window === void 0 || (_window = _window.document) === null || _window === void 0 ? void 0 : _window.activeElement
        }])
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleClosingModal", function (modalToClose) {
      modalToClose.onClose();
      modalToClose.returnFocusTarget.focus();
    });
    _defineProperty(_assertThisInitialized(_this), "closeById", function (id) {
      var modalToClose = _this.state.openModalLayers.find(function (modal) {
        return modal.id === id;
      });
      if (!modalToClose) {
        return;
      }
      _this.setState({
        openModalLayers: _this.state.openModalLayers.filter(function (modal) {
          return modal.id !== id;
        })
      });
      _this.handleClosingModal(modalToClose);
    });
    _defineProperty(_assertThisInitialized(_this), "getMostRecentModal", function () {
      return _this.state.openModalLayers[_this.state.openModalLayers.length - 1];
    });
    _defineProperty(_assertThisInitialized(_this), "closeModal", function (id) {
      if (_this.state.openModalLayers.length === 0) {
        return;
      }
      if (id) {
        _this.closeById(id);
        return;
      }
      // If a specific identifier is not requested to be closed,
      // close the "highest" (most recently added one)
      var modalToClose = _this.getMostRecentModal();
      _this.setState({
        openModalLayers: _this.state.openModalLayers.slice(0, -1)
      });
      _this.handleClosingModal(modalToClose);
    });
    _this.state = {
      openModalLayers: []
    };
    _this.openModal = _this.openModal.bind(_assertThisInitialized(_this));
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_this));
    _this.handleClosingModal = _this.handleClosingModal.bind(_assertThisInitialized(_this));
    _this.closeById = _this.closeById.bind(_assertThisInitialized(_this));
    _this.getMostRecentModal = _this.getMostRecentModal.bind(_assertThisInitialized(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ModalProvider, [{
    key: "handleKeyPress",
    value: function handleKeyPress(e) {
      if ((e === null || e === void 0 ? void 0 : e.key) === 'Escape' && this.state.openModalLayers.length > 0) {
        var _this$getMostRecentMo, _this$getMostRecentMo2;
        ((_this$getMostRecentMo = this.getMostRecentModal()) === null || _this$getMostRecentMo === void 0 || (_this$getMostRecentMo2 = _this$getMostRecentMo.onEscape) === null || _this$getMostRecentMo2 === void 0 ? void 0 : _this$getMostRecentMo2.call(_this$getMostRecentMo)) || this.closeModal();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _window2;
      (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.document) === null || _window2 === void 0 || _window2.addEventListener('keydown', this.handleKeyPress);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _window3;
      (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.document) === null || _window3 === void 0 || _window3.removeEventListener('keydown', this.handleKeyPress);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _window4;
      var appElement = (_window4 = window) === null || _window4 === void 0 || (_window4 = _window4.document) === null || _window4 === void 0 ? void 0 : _window4.getElementById(this.props.appElementId);
      if (this.state.openModalLayers.length > 0) {
        // main application should not be discoverable by screen reader
        appElement === null || appElement === void 0 || appElement.setAttribute('aria-hidden', 'true');
      } else {
        appElement === null || appElement === void 0 || appElement.removeAttribute('aria-hidden');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _window5,
        _this2 = this;
      var _this$props = this.props,
        children = _this$props.children,
        targetElementId = _this$props.targetElementId;
      if (!_isBrowser["default"]) {
        return children;
      }
      var targetElement = (_window5 = window) === null || _window5 === void 0 || (_window5 = _window5.document) === null || _window5 === void 0 ? void 0 : _window5.getElementById(targetElementId);
      return /*#__PURE__*/_react["default"].createElement(ModalContext.Provider, {
        value: {
          openModalLayers: this.state.openModalLayers,
          hasOpenModal: Boolean(this.state.openModalLayers.length),
          openModal: this.openModal,
          closeModal: this.closeModal,
          getMostRecentModal: this.getMostRecentModal
        }
      }, children, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.TransitionGroup, {
        appear: true,
        component: null
      }, this.state.openModalLayers.map(function (modal, idx) {
        return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
          classNames: ROOT_TRANSTION_CLASS,
          key: modal.id || modal.ariaLabelledBy || idx,
          timeout: {
            enter: parseInt(_sharedVariables.variables.defaultAnimationEntranceDuration, 10),
            exit: parseInt(_sharedVariables.variables.defaultAnimationExitDuration, 10)
          }
        }, /*#__PURE__*/_react["default"].createElement(_modalPortal["default"], {
          ariaHidden: idx !== _this2.state.openModalLayers.length - 1,
          closeModal: _this2.closeModal,
          modal: modal,
          targetElement: targetElement
        }));
      })));
    }
  }]);
  return ModalProvider;
}(_react.Component);
ModalProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * String id attribute which is set on the root of your React application.
   * Modal provider will mark this element as aria-hidden while any modal is open.
   */
  appElementId: _propTypes["default"].string,
  /**
   * The portion of the React application that will have access to the ModalProvider
   * 'openModal' and 'closeModal' methods. Generally, the ModalProvider should be near
   * the root of your React app.
   */
  children: _propTypes["default"].any,
  /**
   * String id attribute on the element to which modals will be attached.
   */
  targetElementId: _propTypes["default"].string
} : {};
var _default = exports["default"] = ModalProvider;